/**
 * 全站公共事件。STATSIG.COMMON.FEEDBACK → FEEDBACK
 * STATSIG.COMMON.VIEW → PAGE_VIEW
 *
 * 正在用：FloatingFeedback。侧边栏 Send feedback、报错 Report issue、
 * User Management Support、Public Site Integration Contact support，
 * 都打开同一弹窗；点 Submit 落库。
 * 已不算：选 Product / Feature、上传附件、最小化、关闭、成功弹窗。
 * GuidelineGPT ChatFeedback、旧页 /app/feedback 不算。
 *
 * 页面访问统一 PAGE_VIEW。value 与 metadata.page 相同，一律菜单明文小写下划线。
 * Management 下加 mgmt_ 前缀，Settings 下加 settings_ 前缀。
 */
export enum CommonEvent {
    /**
     * 打开 Feedback 弹窗，或点 Submit 落库。
     * value=open|submit
     * 属性 source=send_feedback|report_issue|support|contact_support（value=open）
     * 属性 form=feedback|issue（value=submit）
     */
    FEEDBACK = 'FEEDBACK',
    /**
     * 打开页面。
     * value 与 metadata.page 相同，见 PAGE
     */
    VIEW = 'PAGE_VIEW',
}

/**
 * PAGE_VIEW 的 page 名。一律用菜单明文转小写下划线。
 * Management 加 mgmt_，Settings 加 settings_，避免和侧栏同名项撞在一起。
 */
export const PAGE = {
    /** 菜单 Dashboard */
    DASHBOARD: 'dashboard',
    /** 侧栏 Loans */
    LOANS: 'loans',
    /** Management Loans */
    MGMT_LOANS: 'mgmt_loans',
    /** 贷款工作台，菜单没有单独项 */
    LOAN: 'loan',
    /** 菜单 Borrowers */
    BORROWERS: 'borrowers',
    /** Borrowers 同页档案，菜单没有单独项 */
    BORROWER: 'borrower',
    /** 菜单 Rates */
    RATES: 'rates',
    /** 菜单 Affordability / Affordability check */
    AFFORDABILITY: 'affordability_calculator',
    /** /app/landingpage，菜单 Personal site & Bluerate */
    PERSONAL_SITE_BLUERATE: 'personal_site_bluerate',
    /** 菜单 Growth hub */
    GROWTH_HUB: 'growth_hub',
    /** /app/openhousefinder，菜单 Open house finder */
    OPEN_HOUSE_FINDER: 'open_house_finder',
    /** Management Application Setting */
    APPLICATION_SETTING: 'mgmt_application_setting',
    /** Management Lenders */
    LENDERS: 'mgmt_lenders',
    /** Management Call Reports */
    CALL_REPORTS: 'mgmt_call_reports',
    /** Management Company Profile */
    COMPANY_PROFILE: 'mgmt_company_profile',
    /** Settings Communication Setup */
    COMMUNICATION_SETUP: 'settings_communication_setup',
    /** Management Communication Setup */
    MGMT_COMMUNICATION_SETUP: 'mgmt_communication_setup',
    /** Management Public Site Integration */
    PUBLIC_SITE_INTEGRATION: 'mgmt_public_site_integration',
    /** Management Team Credit Report */
    TEAM_CREDIT_REPORT: 'mgmt_team_credit_report',
    /** Management User Management */
    USER_MANAGEMENT: 'mgmt_user_management',
    /** Management Closing Cost Setting */
    CLOSING_COST_SETTING: 'mgmt_closing_cost_setting',
    /** Management Plans And Pricing */
    PLANS_AND_PRICING: 'mgmt_plans_and_pricing',
    /** Management Billing Management */
    BILLING_MANAGEMENT: 'mgmt_billing_management',
    /** Settings Profile */
    PROFILE: 'settings_profile',
    /** Management Profile */
    MGMT_PROFILE: 'mgmt_profile',
    /** Settings Feature Customization */
    FEATURE_CUSTOMIZATION: 'settings_feature_customization',
    /** Management Feature customization */
    MGMT_FEATURE_CUSTOMIZATION: 'mgmt_feature_customization',
    /** Settings Document Templates */
    DOCUMENT_TEMPLATES: 'settings_document_templates',
    /** 侧栏 Strata AI（/app/mortgagegpt） */
    STRATA_AI: 'strata_ai',
    /** Settings Strata AI */
    SETTINGS_STRATA_AI: 'settings_strata_ai',
    /** Settings Credit Report */
    CREDIT_REPORT: 'settings_credit_report',
    /** Management Credit report */
    MGMT_CREDIT_REPORT: 'mgmt_credit_report',
    /** GMCC Specials One Page App Setup */
    ONE_PAGE_APP_SETUP: 'one_page_app_setup',
    /** Settings One Page App Setup */
    SETTINGS_ONE_PAGE_APP_SETUP: 'settings_one_page_app_setup',
    /** Settings Open House Sign-in */
    OPEN_HOUSE_SIGN_IN: 'settings_open_house_sign_in',
    /** 菜单 Flyers hub */
    FLYERS_HUB: 'flyers_hub',
    /** 菜单 Diamond */
    DIAMOND: 'diamond',
    /** /login */
    LOGIN: 'login',
    /** /signup */
    SIGNUP: 'signup',
    /** /signupAndPayment?page=plan 注册后选套餐 */
    SIGNUP_PLAN: 'signup_plan',
    /** /signupAndPayment 付款页（选付费套餐后，或 page=pay） */
    SIGNUP_PAYMENT: 'signup_payment',
} as const

export type StatsigPageName = (typeof PAGE)[keyof typeof PAGE]

/** /app/management 用 mgmt_，Settings 用 settings_。 */
export function pageByMenu(managementPage: StatsigPageName, settingsPage: StatsigPageName): StatsigPageName {
    return window.location.pathname.includes('/app/management') ? managementPage : settingsPage
}
